module.exports = __webpack_public_path__ + "img/mini-portrait.48ab840.png";